export const AUTHORIZATION_API = 'authorizationApiUrl';
export const SEALING_SERVER_API = 'sealingServerApiUrl';
export const MARKUP_URL = 'markupUrl';
export const REVIEW_URL = 'reviewUrl';
export const DESIGN_SERVICE_API = 'designServiceApiUrl';
export const DESIGN_URL = 'designUrl';
export const SYNCHRONIZATION_SERVER = 'synchronizationServerUrl';
export const SYNCHRONIZATION_SERVER_API = 'synchronizationServerApiUrl';
